import * as React from 'react';

import { enumBookingStatus } from '@rematter/frontend-lib-api-client';
import { useAtomValue, useSetAtom } from 'jotai';

import {
  $bookingIsMissingRequired,
  $updateBooking,
} from '../../_state/bookingDetail.state';
import { $updateDraftBooking } from '../../_state/bookingForm.state';
import { BookingRecord } from '../../types/booking';

import { EntityTabNotes } from '~/shared/components/EntityTabNotes';

type Props = {
  booking: BookingRecord;
};

export const BookingTabNotes: React.FC<Props> = ({ booking }) => {
  const updateBookingMutation = useSetAtom($updateBooking);
  const updateDraftBookingMutation = useSetAtom($updateDraftBooking);
  const isMissingRequired = useAtomValue($bookingIsMissingRequired);
  const isDraftStatus = booking.status === enumBookingStatus.Draft;

  const isReadonly =
    booking.status === enumBookingStatus.Completed ||
    booking.status === enumBookingStatus.Voided;

  const handleSave = React.useCallback(
    async (notes: {
      internalNotes: string;
      externalNotes: string;
    }): Promise<void> => {
      if (isMissingRequired && isDraftStatus) {
        await updateDraftBookingMutation({
          id: booking.id,
          ...notes,
        });
      } else {
        await updateBookingMutation({
          id: booking.id,
          ...notes,
        });
      }
    },
    [
      booking.id,
      updateBookingMutation,
      updateDraftBookingMutation,
      isMissingRequired,
      isDraftStatus,
    ],
  );

  return (
    <EntityTabNotes
      key={booking.id}
      className="@BookingTabNotes"
      counterparty="customer"
      isReadonly={isReadonly}
      internalNotes={booking.internalNotes ?? ''}
      externalNotes={booking.externalNotes ?? ''}
      onSave={handleSave}
    />
  );
};
